export const version = '0.817.0'
export const chameleonWebVersion = '10.6.3'
export const chameleonCoreVersion = '7.15.1'
